import React, { Component } from "react";
import {
  Modal,
  GET,
  loading,
  NavbarCustomer,
  Pagination,
  format_date,
  t
} from "../../components/CustomComponent.js";

export default class ServiceRequestList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // -----------------------------------
      // Filter States
      // -----------------------------------
      filter_search: "",
      filter_status: "",
      filter_priority_id: "",

      count: 0,
      page: 1,
      page_size: 10,

      data: [],
      data_priorities: [],

      modal_view: false,
      view_item: null,
    };
  }

  async componentDidMount() {
    await this.GetOptions();
    await this.Get(1);
    loading(false);
  }

  GetOptions = async () => {
    const result = await GET("customer/work-requisitions/options");
    if (result?.status) {
      this.setState({
        data_priorities: (result.data?.priorities || []).map((e) => ({ ...e, value: e.uid, label: e.name_th })),
      });
    }
  };

  Get = async (page = 1) => {
    loading(true);

    const result = await GET("customer/work-requisitions", {
      page,
      page_size: this.state.page_size,
      data_search: this.state.filter_search || "",
      status: this.state.filter_status || "",
      work_requisition_priorities_id: this.state.filter_priority_id || "",
    });

    if (result?.status === true) {
      this.setState({
        data: result.data || [],
        count: result.pagination?.count || 0,
        page,
      });
    }

    loading(false);
  };

  resetFilter = () => {
    this.setState({ filter_search: "", filter_status: "", filter_priority_id: "" }, () => this.Get(1));
  };

  openView = (item) => {
    this.setState({ modal_view: true, view_item: item });
  };

  closeView = () => {
    this.setState({ modal_view: false, view_item: null });
  };

  priorityStyle = (priority) => ({
    backgroundColor: priority?.background_color || "#0d6efd",
    color: priority?.font_color || "#fff",
  });

  getStatusBadgeClass = (status) => {
    const statusKey = (status || "").toLowerCase();

    if (statusKey === "pending") {
      return "bg-warning-light text-warning border border-warning";
    }
    if (statusKey === "pending_approval") {
      return "";
    }
    if (statusKey === "approved") {
      return "bg-info-light text-info border border-info";
    }
    if (statusKey === "success") {
      return "bg-success-light text-success border border-success";
    }
    if (statusKey === "cancel" || statusKey === "cancelled" || statusKey === "rejected") {
      return "bg-secondary-light text-secondary border border-secondary";
    }

    return "bg-light text-dark border";
  };

  getStatusLabel = (status) => (status || "").replaceAll("_", " ").toUpperCase();

  render() {
    const {
      data, count, page, page_size,
      filter_search, filter_status, filter_priority_id, data_priorities,
      modal_view, view_item,
    } = this.state;

    return (
        <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
            <NavbarCustomer />
            <div className="body p-4 mt-3">
                {/* Header Section */}
                <div className="mb-4">
                    <h3 className="fw-bold mb-1 text-dark">{t("service_requests")}</h3>
                    <div className="text-secondary text-14">{t("view_all_requests_desc")}</div>
                </div>

                <div className="bg-white rounded-4 shadow-sm p-4 mb-4">
                    {/* Top Filter Toolbar */}
                    <div className="d-flex flex-wrap align-items-center gap-3">
                        <div className="position-relative" style={{ maxWidth: "260px", width: "100%" }}>
                            <span className="icon position-absolute top-50 start-0 translate-middle-y ms-3 text-secondary text-12">{""}</span>
                            <input
                                type="text"
                                className="form-control ps-5 rounded-3 bg-white shadow-none"
                                placeholder={t("search")}
                                value={filter_search}
                                onChange={(e) => this.setState({ filter_search: e.target.value })}
                                onKeyUp={(e) => e.key === "Enter" && this.Get(1)}
                            />
                        </div>

                        <select
                            className="form-select wpx-150 rounded-3 text-secondary shadow-none bg-white fw-bold"
                            value={filter_status}
                            onChange={(e) => this.setState({ filter_status: e.target.value })}
                        >
                            <option value="">{t("all_status")}</option>
                            <option value="pending">{t("pending")}</option>
                            <option value="approved">{t("approved")}</option>
                            <option value="open">{t("open")}</option>
                            <option value="success">{t("success")}</option>
                            <option value="rejected">{t("rejected")}</option>
                        </select>

                        <select
                            className="form-select wpx-150 rounded-3 text-secondary shadow-none bg-white fw-bold"
                            value={filter_priority_id}
                            onChange={(e) => this.setState({ filter_priority_id: e.target.value })}
                        >
                            <option value="">{t("all_priority")}</option>
                            {data_priorities.map((p) => (
                                <option key={p.uid} value={p.uid}>
                                    {p.name_th}
                                </option>
                            ))}
                        </select>

                        <div className="d-flex gap-2">
                            <button className="btn btn-secondary px-3 py-2 fw-bold rounded-3 shadow-sm" onClick={() => this.Get(1)}>
                                {t("search")}
                            </button>
                            <button className="btn btn-white border px-3 py-2 fw-bold rounded-3 shadow-sm" onClick={this.resetFilter}>
                                {t("clear_all")}
                            </button>
                        </div>

                        <div className="ms-auto">
                            <button
                                className="btn btn-primary px-3 py-2 fw-bold rounded-3 shadow-sm d-flex align-items-center"
                                onClick={() => {
                                    window.location.href = "/cs/work-requests/create";
                                }}
                            >
                                <span className="me-2 text-16">+</span> {t("new_request")}
                            </button>
                        </div>
                    </div>
                </div>

                {/* Main White Container */}
                <div className="bg-white rounded-4 shadow-sm pb-2 overflow-hidden">
                    {/* Request Table */}
                    <div className="table-responsive">
                        <table className="table table-hover align-middle mb-0" style={{ minWidth: "1200px" }}>
                            <thead>
                                <tr className="text-secondary fw-bold text-12 border-bottom border-light bg-light bg-opacity-50">
                                    <th className="py-3 px-4 border-0">{t("request_id")}</th>
                                    <th className="py-3 border-0">{t("asset")}</th>
                                    <th className="py-3 border-0">{t("problem")}</th>
                                    <th className="py-3 border-0 text-center">{t("priority")}</th>
                                    <th className="py-3 border-0 text-center">{t("status")}</th>
                                    <th className="py-3 border-0 text-center">{t("created")}</th>
                                    <th className="py-3 border-0 text-center">{t("actions")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.length === 0 ? (
                                    <tr>
                                        <td colSpan={7} className="text-center text-secondary py-5">
                                            {t("no_data")}
                                        </td>
                                    </tr>
                                ) : (
                                    data.map((item) => (
                                        <tr key={item.uid} className="border-bottom border-light">
                                            {/* Request ID */}
                                            <td className="py-4 px-4 fw-bold text-primary pointer hover-underline" onClick={() => this.openView(item)}>
                                                {item.wr_number}
                                            </td>

                                            {/* Asset & Location */}
                                            <td>
                                                <div className="fw-bold text-dark text-14">{item.asset?.name || "-"}</div>
                                                <div className="text-secondary text-12">{item.asset?.asset_code || "-"}</div>
                                            </td>

                                            {/* Problem Description */}
                                            <td>
                                                <div
                                                    className="text-dark text-14 text-truncate"
                                                    style={{ maxWidth: "260px" }}
                                                    title={item.title || item.problem_description}
                                                >
                                                    {item.title || item.problem_description}
                                                </div>
                                            </td>

                                            {/* Priority */}
                                            <td className="text-center">
                                                <span className="badge rounded-pill px-3 py-1 fw-bold text-10" style={this.priorityStyle(item.priority)}>
                                                    {item.priority?.name_th || "-"}
                                                </span>
                                            </td>

                                            {/* Status */}
                                            <td className="text-center">
                                                <span
                                                    className={`badge rounded-pill px-3 py-1 text-12 d-inline-flex align-items-center justify-content-center ${this.getStatusBadgeClass(item.status)}`}
                                                    style={item.status === "pending_approval" ? { backgroundColor: "#F3E8FF", color: "#7C3AED", border: "1px solid #C4B5FD" } : undefined}
                                                >
                                                    {this.getStatusLabel(item.status)}
                                                </span>
                                            </td>

                                            {/* Created Date */}
                                            <td className="text-center">
                                                <div className="text-dark text-12 fw-bold">{item.created_at ? format_date(item.created_at, "dd-mm-yyyy hh:mm", "th") : "-"}</div>
                                            </td>

                                            {/* Actions */}
                                            <td className="text-center">
                                                <div className="d-flex justify-content-center align-items-center gap-3">
                                                    <button
                                                        className="btn btn-link text-primary text-decoration-none p-0 fw-bold d-flex align-items-center text-14 pointer"
                                                        onClick={() => this.openView(item)}
                                                    >
                                                        <span className="icon me-1">{""}</span>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Footer Pagination */}
                <div className="d-flex justify-content-between align-items-center p-4 border-top border-light flex-wrap text-secondary text-12">
                    <div>
                        {t("showing")} {data.length === 0 ? 0 : (page - 1) * page_size + 1}-{(page - 1) * page_size + data.length} {t("of")} {count} {t("requests")}
                    </div>
                    <Pagination className="mb-0" count={Math.ceil(count / page_size) || 1} page={page} showFirstButton={false} showLastButton={false} onChange={(_, p) => this.Get(p)} />
                </div>
            </div>

            {/* View Detail Modal */}
            <Modal show={modal_view} onHide={this.closeView} size="lg" centered>
                <Modal.Header className="border-0 pb-2">
                    <Modal.Title className="fw-bold">{view_item?.wr_number}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {view_item && (
                        <>
                            <div className="d-flex align-items-center gap-2 mb-3">
                                <span className="badge rounded-pill px-3 py-1 fw-bold text-10" style={this.priorityStyle(view_item.priority)}>
                                    {view_item.priority?.name_th || "-"}
                                </span>
                                <span
                                    className={`badge rounded-pill px-3 py-1 text-12 d-inline-flex align-items-center justify-content-center ${this.getStatusBadgeClass(view_item.status)}`}
                                    style={view_item.status === "pending_approval" ? { backgroundColor: "#F3E8FF", color: "#7C3AED", border: "1px solid #C4B5FD" } : undefined}
                                >
                                    {this.getStatusLabel(view_item.status)}
                                </span>
                            </div>

                            <div className="row g-3 mb-3">
                                <div className="col-md-6">
                                    <div className="text-secondary text-12">{t("asset")}</div>
                                    <div className="fw-bold text-dark">{view_item.asset?.name || "-"}</div>
                                    <div className="text-secondary text-12">{view_item.asset?.asset_code || "-"}</div>
                                </div>
                                <div className="col-md-6">
                                    <div className="text-secondary text-12">{t("req_category")}</div>
                                    <div className="fw-bold text-dark">{view_item.category?.name_th || "-"}</div>
                                </div>
                                <div className="col-md-6">
                                    <div className="text-secondary text-12">{t("contact_person")}</div>
                                    <div className="fw-bold text-dark">{view_item.contact_name_1 || "-"}</div>
                                </div>
                                <div className="col-md-6">
                                    <div className="text-secondary text-12">{t("phone_number")}</div>
                                    <div className="fw-bold text-dark">{view_item.contact_phone_1 || "-"}</div>
                                </div>
                            </div>

                            <div className="mb-3">
                                <div className="text-secondary text-12 mb-1">{t("problem_description")}</div>
                                <div className="bg-light rounded-3 p-3 text-dark text-14">{view_item.problem_description || "-"}</div>
                            </div>

                            {view_item.attachments?.length > 0 && (
                                <div>
                                    <div className="text-secondary text-12 mb-2">{t("attach_photos_documents")}</div>
                                    <div className="d-flex flex-wrap gap-2">
                                        {view_item.attachments.map((f) => (
                                            <a key={f.uid} href={f.file_path} target="_blank" rel="noreferrer" className="btn btn-white border rounded-3 px-3 py-2 text-13 text-dark">
                                                <span className="icon me-1">{""}</span>
                                                {f.file_name || f.file_path}
                                            </a>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer className="border-0">
                    <button className="btn btn-white border px-3 py-2 fw-bold rounded-3" onClick={this.closeView}>
                        {t("cancel")}
                    </button>
                </Modal.Footer>
            </Modal>
        </div>
    );
  }
}
